import { render } from "./EditServiceReport2.vue?vue&type=template&id=1c3442e0"
import script from "./EditServiceReport2.vue?vue&type=script&lang=js"
export * from "./EditServiceReport2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__